<template>
  <div class="grid">
    <div class="flex col-12 justify-content-center" v-if="loading"
         style="position: absolute;top: 50%;transform: translate(0, -50%);">
      <ProgressSpinner></ProgressSpinner>
    </div>
    <div class="col-12" v-show="!loading">
      <Card>
        <template #title>Повторная отправка событий</template>
        <template #content>
          <div class="field mb-3">
            <label>Выберите бюро</label>
            <div class="flex flex-wrap gap-3">
              <div v-for="bureau in bureausOptions" :key="bureau.value" class="flex align-items-center">
                <Checkbox v-model="selectedBureaus" :inputId="bureau.value" :value="bureau.value" />
                <label :for="bureau.value" class="ml-2">{{ bureau.label }}</label>
              </div>
            </div>
          </div>
          <AbstractForm
              ref="form"
              :loading="formLoading"
              :on-commit="createResendEvents"
              v-model="listForm"
              commit-label="Отправить события"
              commit-icon="pi pi-send"
          ></AbstractForm>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import AbstractForm from "@/components/AbstractForm.vue";
import FormModel from "@/model/FormModel";
import LoanService from "@/service/LoanService";
import ResponseService from "@/service/ResponseService";
import Checkbox from 'primevue/checkbox';

export default {
  name: "ResendEventsForm",
  components: {AbstractForm, Checkbox},
  props: {
    onCommit: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
      formLoading: false,
      listForm: {
        eventIds: new FormModel('Список событий')
      },
      selectedBureaus: [],
      bureausOptions: [
        { label: 'НБКИ', value: 'nbki' },
        { label: 'Эквифакс', value: 'equ' },
      ]
    }
  },
  methods: {
    createResendEvents() {
      if (this.selectedBureaus.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Не выбрано ни одно бюро',
          detail: 'Выберите хотя бы одно бюро для отправки событий.',
          life: 3000
        });
        return;
      }

      let value = this.listForm.eventIds.value;
      value = value.replace(/[\W,]/g, ' ').replace(/\s\s+/g, ' ')
      value = value.trim().split(/\s/).map((el) => parseInt(el))

      this.$confirm.require({
        message: this.getConfirmMessage(value),
        header: 'Подтвердите отправку событий',
        acceptLabel: 'Подтвердить',
        acceptIcon: 'pi pi-send',
        rejectLabel: 'Отмена',
        rejectIcon: 'pi pi-ban',
        accept: () => {
          this.setLoading(true);

          LoanService.resendEvents(value, this.selectedBureaus).then((res) => {
            if (!res.error) {
              this.$toast.add({
                severity: 'success',
                summary: 'Отправка событий успешно начата',
                detail: res.feedback,
                life: 3000
              })
              this.$refs.form.clear()
              return;
            }

            this.$toast.add({
              severity: 'error',
              summary: 'Ошибка отправки событий',
              detail: res.feedback || 'Произошла ошибка при отправке событий',
              life: 15000
            })
          })
              .catch((err) => {
                ResponseService.handleErrorResponseWithoutForm(err, this.$toast)
              })
              .finally(() => {
                this.setLoading(false);
              })
        }
      })
    },
    getConfirmMessage(events) {
      return `Отправить ${events.length} событий?`;
    },
    setLoading(value) {
      this.loading = value
    },
    clear() {
      this.$refs.form.clear();
    }
  }
}
</script>